import {
  concat,
  toUpper,
  pathOr,
  drop,
  join,
  map,
  split
} from 'ramda';

export const capitalize = (name: string | undefined) => {
  return concat(
    toUpper(
      pathOr('', [0], name)
    ),
    drop(1, name || ''));
};

export const capitalizeAllWords = (s: string) => {
  return join(" ", map(capitalize, split(" ", s || '')));
};
